import React from 'react';
import { RefreshCw, ChevronRight } from 'lucide-react';
import { useCountUp } from '../../../lib/countUp';

const usd = (v) => `$${(v ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}`;

// Valore con conteggio cifre opzionale (solo al primo caricamento, formato identico)
const UsdValue = ({ value, animate = false }) => {
  const shown = useCountUp(typeof value === 'number' ? value : null, animate);
  return <>{usd(typeof shown === 'number' ? shown : value)}</>;
};

// Riepilogo aggregato: due pannelli a righe sottili. Nessun calcolo qui, solo aspetto.
export const AggregateSummaryCard = ({
  summary, title = 'Riepilogo Aggregato', onRefresh, loading = false,
  profitsAction = null, profitsSelector = null, emptyProfits = null, testId = 'aggregate-summary-card',
  animateNumbers = false,
}) => {
  if (!summary) return null;
  const profits = summary.profits || {};
  const capital = summary.capital || {};

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-testid={testId}>
      {/* Profitti Aggregati */}
      <div className="ht-panel neon n2 p-4" data-net-exclude>
        <div className="flex items-center justify-between gap-3 mb-2">
          <h3 className="ht-panel-title text-base">Profitti Aggregati</h3>
          <div className="flex items-center gap-2">
            {profitsAction}
            {onRefresh && (
              <button onClick={onRefresh} className="ht-btn ht-btn-icon" disabled={loading} data-testid={`${testId}-refresh`} title="Aggiorna">
                <RefreshCw size={13} className={loading ? 'animate-spin' : ''} />
              </button>
            )}
          </div>
        </div>
        {profitsSelector}
        {profits.selected_count > 0 ? (
          <div className="ht-rows">
            {[['Oggi', profits.today], ['Settimana', profits.week], ['Mese', profits.month]].map(([label, value]) => (
              <div className="ht-row" key={label}>
                <span className="ht-row-label">{label}</span>
                <span className={`ht-row-value ${(value || 0) > 0 ? 'ht-pos' : 'ht-off'}`}>
                  <UsdValue value={value} animate={animateNumbers} />
                </span>
              </div>
            ))}
          </div>
        ) : emptyProfits}
      </div>

      {/* Capitale Totale in Gestione */}
      <div className="ht-panel neon n2 p-4" data-net-exclude>
        <h3 className="ht-panel-title text-base mb-2">Capitale Totale in Gestione</h3>
        <div className="ht-rows">
          <div className="ht-row">
            <span className="ht-row-label">Valore Conti Totali</span>
            <span className="ht-row-value">
              {usd(capital.accounts_value)}
              <span className="block ht-row-sub">
                {capital.total_accounts || 0} conti: {capital.active_slots || 0} attivi + {capital.ready_accounts || 0} pronti
              </span>
            </span>
          </div>
          <div className="ht-row">
            <span className="ht-row-label">Wallet Totale</span>
            <span className="ht-row-value">
              {usd(capital.wallet_total)}
              <span className="block ht-row-sub">{capital.wallet_unique_addresses || 0} wallet</span>
            </span>
          </div>
          <div className="ht-row">
            <span className="ht-row-label">Broker Totale</span>
            <span className="ht-row-value">{usd(capital.broker_total)}</span>
          </div>
          <div className="ht-row">
            <span className="ht-row-label text-white">Capitale totale (incl. margine a mercato)</span>
            <span className="ht-row-value text-white text-base">{usd(capital.total)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AggregateSummaryCard;
